import { render, staticRenderFns } from "./deletebe.vue?vue&type=template&id=50e2a711&scoped=true"
import script from "./deletebe.vue?vue&type=script&lang=js"
export * from "./deletebe.vue?vue&type=script&lang=js"
import style0 from "./deletebe.vue?vue&type=style&index=0&id=50e2a711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2a711",
  null
  
)

export default component.exports